module.exports = __webpack_public_path__ + "static/media/icehockey.092061da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icehockey.svg
// module id = 383
// module chunks = 7